import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex-column ion-justify-content-start ion-align-items-center",
  style: {"border-radius":"4px","width":"100px","height":"100px","text-transform":"uppercase"}
}
const _hoisted_3 = { class: "subtitle-2" }
const _hoisted_4 = { class: "headline-4" }
const _hoisted_5 = { class: "subtitle-1" }
const _hoisted_6 = {
  key: 1,
  class: "flex-column ion-justify-content-start ion-align-items-center",
  style: {"border-radius":"4px","width":"100px","height":"100px","text-transform":"uppercase"}
}
const _hoisted_7 = { class: "subtitle-2" }
const _hoisted_8 = { class: "headline-5 py-2" }
const _hoisted_9 = { class: "subtitle-1" }
const _hoisted_10 = {
  key: 0,
  style: {"margin":"0"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 1,
  class: "pa-4 ion-text-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "body-2 o-7" }, "Sorry, no events were found.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.events && _ctx.events.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
            return (_openBlock(), _createBlock(_component_ion_card, {
              class: "my-pointer ion-activatable",
              button: "",
              onClick: ($event: any) => (_ctx.$router.push('/home/events/' + event.id)),
              key: event.id + 'event',
              lines: "none",
              style: _normalizeStyle({
        'border-left':
          '6px solid rgb(' +
          _ctx.getColor(event.category ? event.category.name : '') +
          ')',
      })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_ripple_effect),
                _createVNode(_component_ion_grid, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "auto",
                          "size-xs": "4",
                          "size-sm": "auto"
                        }, {
                          default: _withCtx(() => [
                            ((event.startDate && !event.endDate) || (event.startDate == event.endDate))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getMonth(event.startDate)), 1),
                                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getDate(event.startDate)), 1),
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getDay(event.startDate)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ((event.startDate && event.endDate) && (event.startDate != event.endDate))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getMonth(event.startDate)), 1),
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.getDate(event.startDate)) + " - " + _toDisplayString(_ctx.getDate(event.endDate)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_col, {
                          size: "auto",
                          "size-xs": "8",
                          "size-sm": "auto",
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, _toDisplayString(event.Title), 1),
                                (event.startTime && event.endDate)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                                      (event.startTime)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formatNicely(event.startTime)), 1))
                                        : _createCommentVNode("", true),
                                      (event.endTime)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " - " + _toDisplayString(_ctx.formatNicely(event.endTime)), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (event.Details)
                                  ? (_openBlock(), _createElementBlock("pre", {
                                      key: 1,
                                      style: {"margin":"0"},
                                      class: "pt-2",
                                      innerHTML: _ctx.$marked(event.Details.slice(0,150))
                                    }, null, 8, _hoisted_13))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["onClick", "style"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && (!_ctx.events || _ctx.events.length == 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_ion_icon, {
            button: "",
            color: "primary",
            class: "auto pa-4 o-7",
            size: "large",
            icon: _ctx.thumbsDownOutline
          }, null, 8, ["icon"]),
          _hoisted_15
        ]))
      : _createCommentVNode("", true)
  ], 64))
}